module.exports = __webpack_public_path__ + "static/media/AJS_7523.868eb066.jpg";